module.exports = __webpack_public_path__ + "static/media/copy.41f28a05.svg";